module.exports = __webpack_public_path__ + "img/buyClass.6e7a5b44.png";